export {
  default 
} from "./samplePrevArrow";
